export default {
	"order.TheSystemIsOutOfOrder": "The system is out of order",
	"order.AlipayScanCodeSigningContract": "Alipay scan code signing contract",
	"order.PayAndSignUp": "Pay and sign up",
	"order.GoToAlipayToSignAContract": "Go to Alipay to sign a contract"
}